import { DealershipIdentifier } from '~/globals';
import { gqlMutationClient } from '~/lib/backend';

export const prefillByLicensePlateOrVinAction = async ({
  vin,
  state,
  licensePlate,
  dealershipIdentifier
}: {
  vin?: string;
  state?: string;
  licensePlate?: string;
  dealershipIdentifier: DealershipIdentifier;
}) => {
  const resp = await gqlMutationClient(dealershipIdentifier)({
    prefillLicensePlateOrVin: [
      {
        state,
        licensePlate,
        vin
      },
      {
        __typename: true,
        '...on MutationPrefillLicensePlateOrVinSuccess': {
          data: {
            make: true,
            model: true,
            year: true,
            trim: true,
            vin: true
          }
        },
        '...on GraphQLError': { message: true }
      }
    ]
  });

  if (resp.prefillLicensePlateOrVin?.__typename === 'GraphQLError') {
    throw new Error(
      resp.prefillLicensePlateOrVin.message ?? 'Could not fetch prefill values'
    );
  }

  return resp.prefillLicensePlateOrVin?.data;
};
